import { render, staticRenderFns } from "./ProductTypeBadge.vue?vue&type=template&id=60a1470f&"
import script from "./ProductTypeBadge.vue?vue&type=script&lang=js&"
export * from "./ProductTypeBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeBadge.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports